import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionShell, SectionTitle } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const lineItems = [{
  label: '🃏 TRT Decision Deck™ — 6 Premium Volumes',
  value: '$147'
}, {
  label: '🎁 5 Exclusive Bonuses',
  value: '$197'
}];
const perks = ['One-Time Payment', 'Lifetime Access', 'No Monthly Fees', 'Instant Digital Access'];
export function Offer() {
  return <SectionShell data-id="element-208" data-mp="3f38mpubmz4zm">
      <SectionTitle eyebrow="🏆 Special launch offer" title="Here’s everything you get today" data-id="element-209" data-mp="3f2p40be5wckj" />

      <div className="rounded-2xl border border-gold-500/40 bg-navy-950 p-5 sm:p-7" data-id="element-210" data-mp="3jw1rujb0ofc8">
        <ul className="divide-y divide-white/10" data-id="element-211" data-mp="3nwc0y4u3vlvb">
          {lineItems.map(item => <li key={item.label} className="flex items-center justify-between gap-3 py-3" data-id="element-212" data-mp="3sx9e2309dppy">
              <span className="text-sm leading-snug text-sky-100/85 sm:text-base" data-id="element-213" data-mp="1qoqwudbr1y7">
                {item.label}
              </span>
              <span className="shrink-0 font-display text-base text-sky-300 sm:text-lg" data-id="element-214" data-mp="1kjdl5701l31f">
                {item.value}
              </span>
            </li>)}
          <li className="flex items-center justify-between gap-3 py-3" data-id="element-215" data-mp="1bll5g1qertdi">
            <span className="font-display text-base uppercase text-white sm:text-lg" data-id="element-216" data-mp="16m8i7fvmkkae">
              Total value
            </span>
            <span className="shrink-0 font-display text-xl text-sky-100/50 line-through sm:text-2xl" data-id="element-217" data-mp="23aocfp9ojhtu">
              $344
            </span>
          </li>
        </ul>

        <div className="mt-5 rounded-xl bg-navy-800 p-5 text-center" data-id="element-218" data-mp="1uj4g19silk21">
          <p className="font-display text-sm uppercase tracking-[0.15em] text-gold-400" data-id="element-219" data-mp="1uhb9rvltd1uk">
            Today you pay just…
          </p>
          <p className="mt-1 font-display text-6xl leading-none text-white sm:text-7xl" data-id="element-220" data-mp="2n072ane5ytzg">$27</p>
          <ul className="mt-4 grid gap-2 text-left sm:grid-cols-2" data-id="element-221" data-mp="2i8p4u9bcnbj8">
            {perks.map(perk => <li key={perk} className="flex items-center gap-2 text-sm text-sky-100/85" data-id="element-222" data-mp="3157fakc7vepe">
                <CheckIcon className="h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-223" data-mp="3653hqf59my2u" />
                {perk}
              </li>)}
          </ul>
        </div>

        <p className="mt-5 text-sm leading-relaxed text-sky-100/70" data-id="element-224" data-mp="2weqz4sh0hezc">
          For less than the cost of many professional resources, you’ll get a complete collection of
          visual decision cards, clinical cases, maps, and reference tools designed to help organize
          your TRT consultation workflow.
        </p>

        <div className="mt-6" data-id="element-225" data-mp="29f2yevno19sx">
          <CTAButton label="Get the TRT Decision Deck™" subline="One-time payment · $27 · Instant access · 7-day guarantee" data-id="element-226" data-mp="29fvxrbkaox11" />
        </div>

        <p className="mt-3 text-center text-xs text-sky-100/50" data-id="element-227" data-mp="7nzlu0u7tl5q">
          Currency is automatically converted according to your country.
        </p>

        <div className="mt-7" data-id="element-228" data-mp="bm73qz0f0sii">
          <Countdown data-id="element-229" data-mp="1w62hgh8861i2" />
        </div>

        <div className="mt-5" data-id="element-230" data-mp="1w73qyh9lefxo">
          <ScarcityBar data-id="element-231" data-mp="1w47rgoi3jj74" />
        </div>
      </div>
    </SectionShell>;
}